import { apiProvider } from "./core/provider";

const apiWorkAreas = {};

apiWorkAreas.list = function () {
  return apiProvider.get("workareas");
};

apiWorkAreas.create = function (name, dailyCapacity = 0) {
  return apiProvider.post("workareas", { name, dailyCapacity });
};

apiWorkAreas.update = function (id, name, dailyCapacity = 0) {
  return apiProvider.put(`workareas/${id}`, { name, dailyCapacity });
};

apiWorkAreas.addAnchor = function (id, lat, lng, address = "") {
  return apiProvider.post(`workareas/${id}/anchors`, { lat, lng, address });
};

apiWorkAreas.editAnchor = function (id, anchorId, lat, lng, address = "") {
  return apiProvider.put(`workareas/${id}/anchors/${anchorId}`, { lat, lng, address });
};

apiWorkAreas.removeAnchor = function (id, anchorId) {
  return apiProvider.delete(`workareas/${id}/anchors`, anchorId);
};

apiWorkAreas.remove = function (id) {
  return apiProvider.delete("workareas", id);
};

apiWorkAreas.getInspectors = function (id) {
  return apiProvider.get(`workareas/${id}/inspectors`);
};

apiWorkAreas.getCounties = function (id) {
  return apiProvider.get(`workareas/${id}/counties`);
};

apiWorkAreas.addCounty = function (id, countyId) {
  return apiProvider.post(`workareas/${id}/counties`, { countyId });
};

apiWorkAreas.removeCounty = function (id, countyId) {
  return apiProvider.delete(`workareas/${id}/counties`, countyId);
};

apiWorkAreas.addAllCountiesForState = function (id, state) {
  return apiProvider.post(`workareas/${id}/counties/state`, { state });
};

export { apiWorkAreas };
